import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import TestEndModal from "../TestEndModal";
import { formatedTime } from "../../utils/globalFunction";
import httpService from "../../api-services/httpService";
import { clearAnswers } from "../../slices/answerSlice";

const McqPracticeHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const answers = useSelector((state) => state.answer);
  const { topic, difficulty, noOfQuestions } = useParams();

  const [isOpen, setIsOpen] = useState(false);
  const [timer, setTimer] = useState(0);
  const [testEnd, setTestEnd] = useState(false);
  const [isRunning, setIsRunning] = useState(true);

  const [resultResponseData, setResultResponseData] = useState('');

  const [testTime, setTestTime] = useState(() => {
    if (difficulty === "easy") {
      return noOfQuestions * (2 * 60);
    } else if (difficulty === "medium") {
      return noOfQuestions * (3 * 60);
    }
    if (difficulty === "hard") {
      return noOfQuestions * (5 * 60);
    }
  });

  useEffect(() => {
    let intervalId;

    if (isRunning) {
      intervalId = setInterval(() => {
        setTimer((prevTime) => prevTime + 1);
      }, 1000);
    }

    if (timer == testTime) {
      setTestEnd(true);
      setIsRunning(false);
      clearInterval(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isRunning, timer]);

  useEffect(() => {
    if (testEnd) {
      handleSubmit();
    }
  }, [testEnd]);


  const handleSubmit = async () => {
    setIsOpen(true);
    dispatch(clearAnswers());

    try {
      const payload = {
        answers: answers,
        topic: topic,
        difficulty: difficulty,
        numberOfQue: noOfQuestions,
        testTotalDuration: testTime,
        testSubmisionDuration: timer,
        status: 'COMPLETED',
      };

      //Saving to MongoDB database using custom API call.
      const resultRes = await httpService.post(`tests/saveTestResult`, payload)

      if (resultRes) {
        setResultResponseData(resultRes?.data);
        toast.success("Test Submited Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          theme: "dark",
          className: "toastify",
        });
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        theme: "dark",
      });
      return;
    }
  };


  return (
    <div className="mcqPageHeader">
      <div className="mcqPageHeaderDiv">
        <div className="mcqTopic">Mcq Topic: {topic.toUpperCase()}</div>
        <div className="countdown">
          Time: {formatedTime(timer)} / {formatedTime(testTime)}
        </div>
        <div className="totalMcqs">Total Mcqs: {noOfQuestions}</div>
      </div>
      <button onClick={() => handleSubmit()} className="submitBtn">
        Submit Test
      </button>
      <TestEndModal open={isOpen} handleClose={() => setIsOpen(false)} resultData={resultResponseData} />
    </div>
  );
};

export default McqPracticeHeader;
